<template>
    <div v-if="!isLoading">
        <h2>{{ $t("settings.smart-routing.contactList.header") }}</h2>
        <b-form-group
            id="fieldset-contactListIdToFeed"
            :description="$t('settings.smart-routing.contactList.description')"
            :label="$t('settings.smart-routing.contactList.label')"
            content-cols-lg="7"
            content-cols-sm
            label-cols-lg="3"
            label-cols-sm="4"
        >
            <v-select v-model="currentRoute.contactLists" :options="contactLists" label="name" multiple></v-select>
        </b-form-group>
        <h2>{{ $t("settings.smart-routing.contactListToRemove.header") }}</h2>
        <b-form-group
            id="fieldset-contactListIdToFeed"
            :description="$t('settings.smart-routing.contactListToRemove.description')"
            :label="$t('settings.smart-routing.contactListToRemove.label')"
            content-cols-lg="7"
            content-cols-sm
            label-cols-lg="3"
            label-cols-sm="4"
        >
            <v-select
                v-model="currentRoute.contactListsToRemoves"
                :options="contactLists"
                label="name"
                multiple
            ></v-select>
        </b-form-group>
    </div>
</template>

<script>
import { BFormGroup, BFormSelect, BInputGroup } from "bootstrap-vue";
import { onMounted, ref } from "@vue/composition-api";
import useContactsLists from "@/composables/useContactsLists";
import AppUserTeamDropdown from "@/views/modules/settings/smart-routing/components/userTeamDropdown.vue";
import useRoutes from "@/views/modules/settings/smart-routing/useRoutes";
import vSelect from "vue-select";

export default {
    components: {
        AppUserTeamDropdown,
        BFormGroup,
        BFormSelect,
        BInputGroup,
        vSelect,
    },
    setup() {
        const { getAllContactsLists, isLoading } = useContactsLists();
        const { currentRoute } = useRoutes();

        const contactLists = ref([]);
        onMounted(async () => {
            contactLists.value = await getAllContactsLists(true);
        });
        return {
            currentRoute,
            contactLists,
            isLoading,
        };
    },
};
</script>
